import { createRouter, createWebHistory } from 'vue-router'

import routes from './routes'
import { globalBeforeEachGuard } from './guards'

export const routesWithoutHeader = [
  'login',
  'select-company',
  'reset-password',
  'register',
  'lang-register',
  '2fa'
]

const routerMain = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

routerMain.beforeEach(globalBeforeEachGuard)

export default routerMain
